package common

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 07.11.22
 * Author : leonhergt
 */
enum class EConstants(val mId: String) {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    BURGER_MENU_CONTENT("main-content"),

    LOADING_SPINNER_GRADIENT("loading-spinner-gradient"),
    LOADING_SPINNER_HOLE("loading-spinner-hole")

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}